import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { MenuItemToggle } from './accordion.model';

@Injectable({
  providedIn: 'root',
})
export class AccordionService {

  menuItemToggle$ = new BehaviorSubject(new MenuItemToggle());

  constructor() { }

  menuItemToggleChange(menuItem: MenuItemToggle) {
    this.menuItemToggle$.next(menuItem);
  }
}
